import React, { useMemo } from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import styles from './ReminderModal.module.scss';
import { Text } from '../../typography';
import { useLocation, useNavigate } from 'react-router-dom';
import TextWithIcon from '../../typography/TextWithIcon';
import { useQueryParams } from '../../../hooks/misc';
import { modals } from '../../../providers/modals';

const boxShadow = '0 3px 3px rgba(0, 0, 0, 0.2)';
const borderRadius = '12px';
export default function ReminderModal({
  title,
  onClick,
  show,
  message,
  url,
  timer = 0,
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const { getParam } = useQueryParams();
  const isModal = getParam('modalName') === modals.recordMeeting;

  function formatTime(secs) {
    const totalSeconds = Math.floor(secs);
    const minutes = String(Math.floor(totalSeconds / 60)).padStart(2, '0');
    const seconds = String(totalSeconds % 60).padStart(2, '0');
    return `${minutes}:${seconds}`;
  }

  const isOnOriginalPage = useMemo(
    () => location.pathname === url,
    [location, url],
  );
  return (
    <Snackbar
      className={styles.alertContainer}
      open={show}
      TransitionProps={{ timeout: 0 }}
    >
      <Alert
        onClick={onClick}
        severity="warning"
        sx={{ backgroundColor: 'white', boxShadow, borderRadius }}
      >
        <Text weight="semiBold" noMargin>
          {title}
        </Text>
        <div className={styles.flex}>
          <Text noMargin>{formatTime(timer)}</Text>
          {!!url && !isOnOriginalPage && !isModal && (
            <TextWithIcon
              weight="semiBold"
              size="sm"
              link
              onClick={() => navigate(url)}
              noMargin
              hover
            >
              {message || 'Back'}
            </TextWithIcon>
          )}
        </div>
      </Alert>
    </Snackbar>
  );
}
